import { cn } from '@/shared/lib/utils';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';
import * as React from 'react';

/**
 * RDS Checkbox.
 * @see https://www.figma.com/design/wcgji99mZRPIytCZDjwqxe/RDS-v1.0?node-id=77-1203
 */
export const checkboxClassName = cn(
  'group peer size-6 shrink-0 rounded-8 border-[1.5px] border-[#9ea2ae] bg-white',
  'shadow-none transition-[background-color,border-color,box-shadow]',
  'hover:bg-ruda-primary-100',
  'focus-visible:outline-none focus-visible:shadow-[0_0_0_3px_#aeb6fb]',
  'disabled:cursor-not-allowed disabled:border-[#d2d5db] disabled:bg-ruda-grey-100',
  'disabled:hover:bg-ruda-grey-100',
  // Selected / Indeterminate — Primary-600
  'data-[state=checked]:border-transparent data-[state=checked]:bg-ruda-primary-600',
  'data-[state=checked]:text-white data-[state=checked]:hover:bg-ruda-primary-600',
  'data-[state=indeterminate]:border-transparent data-[state=indeterminate]:bg-ruda-primary-600',
  'data-[state=indeterminate]:text-white data-[state=indeterminate]:hover:bg-ruda-primary-600',
);

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(checkboxClassName, className)}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
      <Check className="size-3.5 stroke-[3] group-data-[state=indeterminate]:hidden" />
      <Minus className="hidden size-3.5 stroke-[3] group-data-[state=indeterminate]:block" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
